import { render, staticRenderFns } from "./ResultRowSummary.vue?vue&type=template&id=267735dc&scoped=true"
import script from "./ResultRowSummary.vue?vue&type=script&lang=js"
export * from "./ResultRowSummary.vue?vue&type=script&lang=js"
import style0 from "./ResultRowSummary.vue?vue&type=style&index=0&id=267735dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267735dc",
  null
  
)

export default component.exports